<template>
  <div v-click-outside="hide">
    <!-- 
      The slot is a placeholder for the content that will be passed to the component.
      The content will be rendered in the place of the slot.
    -->
    <slot ref="content"></slot>
    <div class="profile-card" ref="card">
      <div class="card-wrapper" ref="cardwrapper">
        <div class="top">
          <span class="close-popover" @click="hide()">
            <Crossmark color="white" />
          </span>
          <template>
            <div class="user-name">
              <p>
                <b>{{ user.firstName }} {{ user.lastName }}</b>
              </p>
            </div>
            <div class="club">
              <p>
                {{ user.profile.mainClubName || user.profile.club }}
              </p>
            </div>
          </template>
        </div>
        <div class="bottom">
          <UserProfileAvatar
            size="XL"
            :initials="user.firstName[0] + user.lastName[0]"
            :profileImageUrl="user.profile.profileImageUrl"
          />
          <div class="pdga">
            <p v-if="user.profile.pdgaNumber">
              PDGA: <b>{{ user.profile.pdgaNumber }}</b>
            </p>
          </div>
          <div class="rating" v-if="user.profile.pdgaNumber">
            <p>
              Rating: <b>{{ user.profile.pdgaRating || '-' }}</b>
            </p>
          </div>
          <span
            :class="flagClass(user.profile.country.code)"
            v-if="user.profile.country"
          ></span>
          <router-link
            :to="{ name: 'public-user', params: { userId } }"
            class="view-profile"
            >View profile</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Crossmark from '@/assets/icons/Crossmark.vue'
import UserProfileAvatar from '@/components/UIElements/UserProfileAvatar'
import ClickOutside from 'vue-click-outside'
import { createPopper } from '@popperjs/core'

export default {
  name: 'ProfilePopoverCard',
  directives: {
    ClickOutside,
  },
  components: {
    Crossmark,
    UserProfileAvatar,
  },
  props: ['userId'],
  data() {
    return {
      popper: null,
      hoverItem: null,
      showEvents: ['click'],
      user: {
        id: ' ',
        firstName: ' ',
        lastName: ' ',
        profile: {
          id: ' ',
          club: ' ',
          mainClubName: ' ',
          mainClubSlug: ' ',
          pdgaNumber: '-',
          pdgaRating: '-',
          profileImageUrl: null,
          country: {
            name: ' ',
            code: ' ',
          },
        },
      },
    }
  },
  watch: {},
  computed: {},
  methods: {
    flagClass(countryCode) {
      return `fib fi-${countryCode.toLowerCase()}`
    },
    async loadData() {
      try {
        const response = await this.$axios({
          data: {
            query: `
            {
              user(userId: "${this.userId}") {
                id
                firstName
                lastName
                profile {
                  id
                  club
                  mainClubName
                  mainClubSlug
                  pdgaNumber
                  pdgaRating
                  profileImageUrl
                  country{
                    name
                    code
                  }
                }
              }
            }
          `,
          },
        })

        this.user = response.data.data.user
      } catch (error) {
        console.log(error)
      }
    },
    async show() {
      await this.loadData()
      this.showEvents.forEach((event) => {
        this.hoverItem.addEventListener(event, this.show)
      })
      this.$refs.card.setAttribute('data-show', '')
      this.$nextTick(() => {
        this.$refs.cardwrapper.classList.add('show')
      })

      this.popper.setOptions((options) => ({
        ...options,
        modifiers: [
          ...options.modifiers,
          { name: 'eventListeners', enabled: true },
        ],
      }))

      this.popper.update()
    },
    hide() {
      if (this.popper) {
        this.$refs.cardwrapper.classList.remove('show')

        setTimeout(() => {
          if (this.$refs.card) {
            this.$refs.card.removeAttribute('data-show', '')
            this.popper.setOptions((options) => ({
              ...options,
              modifiers: [
                ...options.modifiers,
                { name: 'eventListeners', enabled: false },
              ],
            }))
          }
        }, 150)
      }
    },
  },
  mounted() {
    this.hoverItem = this.$slots.default[0].elm
    this.popper = createPopper(this.hoverItem, this.$refs.card, {
      placement: 'bottom-start',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 10],
          },
        },
      ],
    })

    this.showEvents.forEach((event) => {
      this.hoverItem.addEventListener(event, this.show)
    })
  },
  beforeCreate() {},
  destroyed() {
    if (this.popper) {
      this.showEvents.forEach((event) => {
        this.hoverItem.removeEventListener(event, this.show)
      })
      this.popper.destroy()
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/Typography';

.profile-card {
  position: relative;
  display: none;
  z-index: 3;
}

.card-wrapper {
  cursor: default;
  position: relative;
  opacity: 0;
  transition: all ease 0.3s;
  background: white;
  position: relative;
  border-radius: 10px;
  width: auto;
  max-width: 250px;
  box-shadow: 0px 0px 30px #00000033;
  transition: all ease 0.15s;
  transform-origin: top center;
  transform: scale(0) translate(0, 0, 0);
  will-change: transform;
  &.show {
    opacity: 1;
  }
}

.top {
  border-radius: 10px 10px 0 0;
  background: linear-gradient(0deg, $twilight, $dusk);
  display: flex;
  flex-direction: column;
  padding: 15px 15px 56px 15px;
  align-items: center;
  .close-popover {
    margin: -10px;
    padding: 10px;
    line-height: 10px;
    margin-left: auto;
    cursor: pointer;
    svg {
      width: 10px;
      height: 10px;
    }
  }
  .user-name {
    margin-top: 15px;
    overflow: hidden;
    max-width: 100%;
    p {
      text-overflow: ellipsis;
      overflow: hidden;
      text-align: center;
      font-size: 20px;
      color: white;
    }
  }
  .club {
    margin-top: 6px;
    p {
      overflow: hidden;
      text-align: center;
      @include Gilroy-LightItalic;
      font-size: 14px;
      color: white;
    }
  }
}
.bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 28px;
  .user-profile-avatar,
  .user-profile-image {
    margin-top: -36px;
  }

  .fib {
    margin-top: 16px;
    box-shadow: 0 0 0 1px $midnight;
    overflow: hidden;
    width: 36px;
    display: block;
    aspect-ratio: 4/3;
  }
  .pdga {
    margin-top: 20px;
  }

  .view-profile {
    margin-top: 16px;

    color: $ocean;

    &:hover {
      text-decoration: underline;
    }

    p {
      font-size: 14px;
    }
  }
}

.profile-card[data-show] {
  display: block;
  min-width: 225px;
}

@media (min-width: 480px) and (orientation: landscape) {
}

@media (min-width: 544px) {
}

@media (min-width: 768px) {
}

@media (min-width: 1200px) {
}
</style>
